import xtermCss from "@xterm/xterm/css/xterm.css?inline";
import css from "./nodes.css?inline";

let sheet: CSSStyleSheet | null = null;

/**
 * One constructed stylesheet, adopted by every window's shadow root.
 *
 * Shared rather than duplicated per window: the browser parses it once and each
 * shadow root just references it.
 */
export function nodeStyleSheet(): CSSStyleSheet {
  if (sheet === null) {
    sheet = new CSSStyleSheet();
    // xterm's own stylesheet has to be *inside* the shadow root: a terminal
    // surface renders there, and a document-level stylesheet would not reach
    // it. This is the cost of the shadow boundary, paid once.
    sheet.replaceSync(xtermCss + "\n" + css);
  }
  return sheet;
}
